import { render, staticRenderFns } from "./personnelCalibration.vue?vue&type=template&id=8f5c5026&scoped=true"
import script from "./personnelCalibration.vue?vue&type=script&lang=js"
export * from "./personnelCalibration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c5026",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f5c5026')) {
      api.createRecord('8f5c5026', component.options)
    } else {
      api.reload('8f5c5026', component.options)
    }
    module.hot.accept("./personnelCalibration.vue?vue&type=template&id=8f5c5026&scoped=true", function () {
      api.rerender('8f5c5026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sensory/sensory-calibration/personnelCalibration.vue"
export default component.exports